<template>
  <svg
    class="icon"
    :class="fill != '' ? 'fill-' + fill : ''"
  >
    <title v-if="title">
      {{ title }}
    </title>
    <use
      xmlns:xlink="http://www.w3.org/1999/xlink"
      :xlink:href="'#icon-' + name"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'SvgIcon',
  props: {
    name: { type: String, required: true },
    fill: { type: String, default: '' },
    title: { type: String, default: null },
  },
}
</script>
